"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MOLAdminComplete = void 0;
const MOLAdmin_1 = require("./MOLAdmin");
/**
 * Full admin user as stored on AWS Cognito
 */
class MOLAdminComplete extends MOLAdmin_1.MOLAdmin {
    constructor(props) {
        super(props);
    }
}
exports.MOLAdminComplete = MOLAdminComplete;
//# sourceMappingURL=MOLAdminComplete.js.map